import styled from 'styled-components'

const RequiredField = ({ children }) => <StyledSpan>{children}</StyledSpan>

const StyledSpan = styled.span`
  color: #d32f2f;
  font-weight: bold;
  font-size: 15px;
`

export default RequiredField
